export default {"src":"/_next/static/image/public/images/flags/flag_30.103383f832fb06abbc2fbe5b2d9959e3.svg","height":16,"width":25};